import { useState } from 'react';
import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import MuiToolbar from '@mui/material/Toolbar';
import { tabsClasses } from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded';
import SideMenuMobile from './SideMenuMobile.tsx';

const Toolbar = styled(MuiToolbar)({
	width: '100%',
	padding: '12px',
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'start',
	justifyContent: 'center',
	gap: '12px',
	flexShrink: 0,
	[`& ${tabsClasses.list}`]: {
		gap: '8px',
		p: '8px',
		pb: 0,
	},
});

export default function AppNavbar() {
	const [open, setOpen] = useState(false);

	const toggleDrawer = (newOpen: boolean) => () => {
		setOpen(newOpen);
	};

	return (
		<AppBar
			position="fixed"
			sx={{
				display: { xs: 'auto', md: 'none' },
				boxShadow: 0,
				bgcolor: 'background.paper',
				backgroundImage: 'none',
				borderBottom: '1px solid',
				borderColor: 'divider',
				zIndex: (theme) => theme.zIndex.drawer - 1,
			}}
		>
			<Toolbar variant="regular">
				<Stack
					direction="row"
					sx={{
						alignItems: 'center',
						flexGrow: 1,
						width: '100%',
						gap: 1,
					}}
				>
					<Stack
						direction="row"
						spacing={1}
						sx={{ justifyContent: 'center', mr: 'auto' }}
					>
						<CustomIcon />
						<Typography variant="h6" component="h1" sx={{ color: 'text.primary' }}>
							Quản lý thông tin tuyển sinh
						</Typography>
					</Stack>
					<IconButton
						aria-label="menu"
						onClick={toggleDrawer(true)}
						sx={{ color: 'text.primary' }}
					>
						<MenuRoundedIcon />
					</IconButton>
					<SideMenuMobile open={open} toggleDrawer={toggleDrawer} />
				</Stack>
			</Toolbar>
		</AppBar>
	);
}

export function CustomIcon() {
	return (
		<Box
			sx={{
				width: '1.5rem',
				height: '1.5rem',
				borderRadius: '999px',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				alignSelf: 'center',
				backgroundImage:
					'linear-gradient(135deg, hsl(210, 98%, 60%) 0%, hsl(210, 100%, 35%) 100%)',
				color: 'hsla(210, 100%, 95%, 0.9)',
				border: '1px solid',
				borderColor: 'hsl(210, 100%, 55%)',
				boxShadow: 'inset 0 2px 5px rgba(255, 255, 255, 0.3)',
			}}
		>
			<SchoolRoundedIcon sx={{ fontSize: '1rem' }} />
		</Box>
	);
}